import { render } from "./PagePopup.vue?vue&type=template&id=873262ee"
import script from "./PagePopup.vue?vue&type=script&lang=js"
export * from "./PagePopup.vue?vue&type=script&lang=js"

import "./PagePopup.vue?vue&type=style&index=0&id=873262ee&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__